// eslint-disable-next-line react/jsx-no-useless-fragment
export const CompanyWrapper = ({ children }) => <>{children}</>;
